// extracted by mini-css-extract-plugin
export default {"cover":"cover---RdWo5","empty":"empty---qh3da"};